'use client';

import { Box } from '@mantine/core';
import classnames from './news.module.css';

export function NewsList({ children }: { children: React.ReactNode }) {
  return <Box className={classnames.news}>{children}</Box>;
}
